export default __webpack_public_path__ + "logo.eeae19f0305b3fc8e78b696c78039326.png";